/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs';

@Injectable()
export class Error {
	type: string;
	severity: number;
	stack: Array<any> = [];
	data: any;

	private defaultSeverity: number = 5;

	constructor(errorData:any) {
		this.type = 'client';
		this.severity = errorData.severity ? errorData.severity : this.defaultSeverity;

		if (errorData.file) {
			this.stack.push({
				file: errorData.file,
				func: errorData.func,
				message: errorData.message
			});
		}
	}

	set Severity(val:number) {
		this.severity = val;
	}

	get Stack(): any {
		return this.stack;
	}
}

@Injectable()
export class ErrorService {

  constructor(private http: HttpClient) { }

  log(error: Response | Error, file?: string, func?: string):void {
  	let errorMessage: string;
  	let e: any;

  	if (error instanceof Response) {
      // likely some unhandled response
      e = error.json();
  	}
  	else if (error instanceof Error) {
      // explicitly passed an error object
  		e = error;
  	}
    else {
      // any object, but hopefully at least looks like an error
			e = new Error({file:'unknown',func:'unknown',message:error});
    }

    if (file && func) {
			if (e.stack_trace) {
      	e.stack_trace.unshift({ file: file, func: func, message: 'check stack trace' })
			}
			else {
				e.stack_trace = [{ file: file, func: func, message: 'check stack trace' } ];
			}
    }

    // fire and forget
    this.http
      .post(
        '/api/v1/error',
        e)
  }
}



// WEBPACK FOOTER //
// ./client/app/services/error.service.ts